import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'smartNumber'
})
export class SmartNumberPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '0';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return '0';
    }

    if (num % 1 === 0) {
      return num.toString();
    }

    return num.toFixed(2).replace(/\.?0+$/, '');
  }
}

